import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface RefreshTable2Response {
  callSuccess: string;
  errorMessage?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class CbcTbl2RefreshService {
  constructor(private http: HttpClient) {}

  private buildParams(
    globalService: any,
    filterParams: any,
    ssoId: string,
    extra: Record<string, string | number | null | undefined> = {}
  ): HttpParams {
    const g = globalService || {};
    const f = filterParams || {};
    let p = new HttpParams();
    if (ssoId) p = p.set('sso_id', ssoId);
    const taxYear = f.tax_year != null ? f.tax_year : g.tax_year;
    if (taxYear != null) p = p.set('tax_year', String(taxYear));
    const scenario = f.scenario != null ? f.scenario : g.scenario;
    if (scenario != null) p = p.set('scenario', String(scenario));
    const jcdKey = f.jcd_key != null ? f.jcd_key : (g.jcd_key != null ? g.jcd_key : 250);
    if (jcdKey != null) p = p.set('jcd_key', String(jcdKey));
    Object.keys(extra).forEach((k) => {
      const v = extra[k];
      if (v !== undefined && v !== null) p = p.set(k, String(v));
    });
    return p;
  }

  refreshTable2Data(
    baseUrl: string,
    ssoId: string,
    filterParams: any = {},
    globalService: any = {}
  ): Observable<RefreshTable2Response> {
    const url = `${baseUrl}/saveJsonObject?action_id=31653`;
    const body = this.buildParams(globalService, filterParams, ssoId).toString();
    return this.http.post<RefreshTable2Response>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
